// src/api/sms/sms.ts
import { api } from "../api";

export interface SendSmsRequest {
    to: string;
    body: string;
}

export interface SendSmsResponse {
    ok: boolean;
    sid: string | null;
    status: string | null;
    to: string | null;
    error_code: number | null;
    error_message: string | null;
    messaging_service_sid: string | null;
    num_segments: string | null;
    from_: string | null;
}

export interface SendUrgentMessageRequest {
    conversation_id: string;
    message: string;
}

export interface SendUrgentMessageResponse {
    ok: boolean;
    message_id: string | null;
    sms_sid: string | null;
    error: string | null;
}

export const smsApi = {
    sendMessage: async (request: SendSmsRequest): Promise<SendSmsResponse> => {
        const { data } = await api.post("/sms/send-message", request);
        return data;
    },
    
    sendUrgentMessage: async (request: SendUrgentMessageRequest): Promise<SendUrgentMessageResponse> => {
        const { data } = await api.post("/sms/send-urgent-message", request);
        return data;
    },
};
